<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>未精算関連承認画面</h1>

<!-- 検索条件コンポーネント -->
<div *ngIf="businessDate && codeConversionMstMap?.size > 0">
    <form [formGroup]="sgke092arequestData" (ngSubmit)="onClickSearch()">
        <app-sgke090d-condition [codeConversionMstMap]="codeConversionMstMap" [businessDate]="businessDate"
            (onClickClearEvent)="onClickClear()">
        </app-sgke090d-condition>
    </form>
</div>

<!-- 検索結果コンポーネント -->
<div *ngIf="searchresultList.length > 0">
    <app-sgke090d-result [searchresultList]="searchresultList" (onClickApprovalEvent)="onClickApproval($event)"
        (clearMessageEmit)="clearErrorMsg()"(onDblClickFlgEmitter)="dblClickFlgSet()">
    </app-sgke090d-result>
</div>